/**
 * 活版印刷の注文（js/order-letterpress-both.js の ESM 版。処理は utils/order-letterpress.ts）
 */
import '@/order-common'
import { initLetterpressOrder } from '@/utils/order-letterpress'

initLetterpressOrder()
